import { EAiModelType } from './e-ai-model-type.enum';

export class AIVideoAnalyzeConfig {
  modelsDirectory: string = '//opt//evrideo//models';
  modelUrl: string = '';
  mergeDetectionConsiderableGap: number = 1;
  modelType: EAiModelType = EAiModelType.Yolo;
  ioUThreshold: number = 0.7;
  modelIoU: number = 0.7;
  modelConfidence: number = 0.7;
  useCuda: boolean = false;
  gpuId: number = 0;
  primeGpu: boolean = false;
  certainty_limit: number = 0.5;
  keyframes_delta_thresh: number = 0.05;
  trajectory: number = 2;

  static DEFAULT(): AIVideoAnalyzeConfig {
    return new AIVideoAnalyzeConfig();
  }
}
